import { render, staticRenderFns } from "./RoomOrderHealth.vue?vue&type=template&id=373bd7b8"
import script from "./RoomOrderHealth.vue?vue&type=script&lang=js"
export * from "./RoomOrderHealth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports